export const formatInsuranceFilter = (object) => {
	if (object && object.company_name) {
		return (
			object.company_name +
			(object.number && object.expiration_date ? ' (n° ' + object.number + ' - ' + object.expiration_date + ')' : '') +
			(object.number && !object.expiration_date ? ' (n° ' + object.number + ')' : '') +
			(!object.number && object.expiration_date ? ' (' + object.expiration_date + ')' : '')
		)
	} else if (!object.company_name) {
		return 'Si'
	}
}



// WEBPACK FOOTER //
// ./src/utils/filters/formatInsurance.js